/*
	Mobile menu promos
	------------------
	Mirrors, inside every top level voice of the mobile drawer menu, the same
	cards that the matching desktop megamenu shows (New: 2 images, Donna: 1,
	Explore: 2). The megamenu markup is already part of the page on mobile, it
	is only hidden by CSS, so the cards are cloned from it: the merchant keeps
	editing the images in one single place, the header megamenu, and the drawer
	follows automatically.

	Pairing:  megamenu  id="SiteNavLabel-{menu title}-megamenu"
	          submenu   id="SiteNavLabel-{link handle}-submenu"
	compared after lowercasing the title and turning its spaces into dashes.
*/

(() => {


	const navKey = value => value.trim().toLowerCase().replace(/\s+/g, '-');

	const megamenusByKey = () => {
		const map = new Map();
		document.querySelectorAll('.kt-megamenu[id^="SiteNavLabel-"]').forEach(megamenu => {
			const match = megamenu.id.match(/^SiteNavLabel-(.+)-megamenu$/);
			if ( match ) map.set(navKey(match[1]), megamenu);
		});
		return map;
	};

	// every column of the megamenu grid that is not a list of links is a card
	const cardsOf = megamenu => megamenu.querySelectorAll('.kt-grid > .kt-grid__item:not(.kt-megamenu-item)');

	const cloneCard = card => {
		const clone = card.cloneNode(true);
		clone.removeAttribute('id');
		clone.querySelectorAll('[id]').forEach(elm => elm.removeAttribute('id'));
		clone.querySelectorAll('script').forEach(elm => elm.remove());
		return clone;
	};

	const fill = () => {

		const megamenus = megamenusByKey();
		if ( ! megamenus.size ) return;

		document.querySelectorAll('mobile-navigation .kt-submenu[id^="SiteNavLabel-"]').forEach(submenu => {

			const match = submenu.id.match(/^SiteNavLabel-(.+)-submenu$/);
			if ( ! match ) return;

			submenu.querySelectorAll(':scope > .kt-mobile-promos').forEach(elm => elm.remove());

			const megamenu = megamenus.get(navKey(match[1]));
			if ( ! megamenu ) return;

			const cards = cardsOf(megamenu);
			if ( ! cards.length ) return;

			const item = document.createElement('li');
			item.className = 'kt-mobile-promos';

			const grid = document.createElement('div');
			grid.className = 'kt-mobile-promos__grid';
			cards.forEach(card => grid.appendChild(cloneCard(card)));

			item.appendChild(grid);
			submenu.appendChild(item);

		});

	};

	// the cloned images stay lazy, but they are inside a submenu that is
	// display:none until its voice is tapped, so they would only start loading
	// at that very moment. As soon as the drawer is opened we switch them to
	// eager: the fetch starts while the first level is still on screen.
	const preload = () => {
		document.querySelectorAll('.kt-mobile-promos img[loading="lazy"]').forEach(img => {
			img.loading = 'eager';
		});
	};

	const watchDrawer = () => {
		const drawer = document.getElementById('site-menu-sidebar');
		if ( ! drawer ) return;
		if ( drawer.classList.contains('kt-sidebar--opened') ) preload();
		new MutationObserver(() => {
			if ( drawer.classList.contains('kt-sidebar--opened') ) preload();
		}).observe(drawer, { attributes: true, attributeFilter: ['class'] });
	};

	const start = () => {
		fill();
		watchDrawer();
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', start, { once: true });
	} else {
		start();
	}

	// the theme editor re-renders the header and the drawer on their own
	document.addEventListener('shopify:section:load', () => requestAnimationFrame(start));

})();
